// [FIX 18, 19] Оставлены только реально используемые импорты
import { Box, Button, Drawer, IconButton, Tooltip, Typography } from "@mui/material";
import { memo, useCallback, useEffect, useMemo, useRef, useState } from "react";

// [FIX 19] lodash используется только для set — импортируем точечно (пункт 32 не трогаем, но улучшаем в рамках 18/19)
import set from "lodash/set";

import { getDataSource } from "api/ds";
import { ReportTable } from "components/reportTable";
import { loginSelector } from "store/slices/loginSlice";
import { useSelector } from "react-redux";
import Loading from "components/Load";
import { getFile, post } from "api/apiBridges/httpBridge";
import { get } from "api/apiBridges/httpBridge";
import ClassicSearch from "components/classicSearch";
import { hoverStyle, hoverStyleTransformOnly, buttonColor, iconColor, buttonColorHover } from "styles/main";
import { useVirtualizer } from "@tanstack/react-virtual";
import { MemoTextField } from "components/MemoTextField";
import AddIcon from "@mui/icons-material/Add";
import SettingsIcon from "@mui/icons-material/Settings";
import { CancelButton, OKButton, TextInputDesign } from "components/EIComponents/LittleComponents";
import { useLocalNotifications } from "components/Events";
import DeleteIcon from "@mui/icons-material/Delete";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { ProductMoreInfo } from "utils/formatters";

// [FIX 34] Единая система размеров — вместо 'pt' используем 'px' через константы
const FONT = {
    cardTitle: 18,      // было 14pt
    cardTag: 16,        // было 12pt
    cardBody: 16,       // было 12pt
    cardPrice: 24,      // было 18pt
};

export function MyTechTasks() {
    /** @type {[Array<any>, Function]} */
    const [data, setData] = useState([]);

    const { user_id, company_id } = useSelector(loginSelector);

    const [loading, setLoading] = useState(true);

    /** @type {[any, Function]} */
    const [edit, setEdit] = useState(undefined);

    const [checked, setChecked] = useState(false);
    /** @type {[any, Function]} */
    const [filter, setFilter] = useState(null);
    const [filterFields, setFilterFields] = useState({
        title: { name: "Название", active: true },
        brand: { name: "Брэнд", active: true },
        vendorCode: { name: "Артикул", active: true },
        barcode: { name: "ШК", active: true },
    });

    /** @type {[any, Function]} */
    const [avaiblePackage, setAvaiblePackage] = useState([]);
    /** @type {[any, Function]} */
    const [avaibleConsumes, setAvaibleConsumes] = useState([]);
    /** @type {[any, Function]} */
    const [services, setServices] = useState([]);
    /** @type {[any, Function]} */
    const [nextVersion, setNextVersion] = useState("TZ_1");
    /** @type {[any, Function]} */
    const [avaibleProducts, setAvaibleProducts] = useState([]);

    const ITEMS_PER_ROW = 3;
    const ROW_HEIGHT = 150;
    /** @type {any} */
    const parentRef = useRef(null);

    // [FIX 22] fetchServices обёрнут в useCallback
    const fetchServices = useCallback(async () => {
        try {
            const responseData = await get("Handbook/getOnName", { company_id, name: "services" });
            if (responseData.message?.[0].data) {
                const $data = JSON.parse(responseData.message[0].data);
                if ($data.values) setServices($data.values);
            }

            const responseDataHB = await get("Handbook/get", { company_id });
            let tmpPackage = [];
            if (responseDataHB.message) {
                responseDataHB.message.forEach((el) => {
                    const elData = JSON.parse(el.data);
                    if (elData.rowPlace?.val === "static.product.package") {
                        tmpPackage = [...tmpPackage, ...elData.values];
                    }
                });
            }
            const tmpPack = [];
            tmpPackage.forEach((el) => {
                tmpPack.push({ id: el.name, name: el.name, val: el.val, count: 1, size: el.size });
            });
            setAvaiblePackage(tmpPack);

            const consres = await get("consumables/getOnCli", { cid: user_id });
            const tmp = [];
            await Promise.all(
                consres.map(async (el) => {
                    let photo = undefined;
                    let photopath = undefined;
                    if (el.photo) {
                        const img = await getFile("png", { path: el.photo });
                        photopath = el.photo;
                        photo = img;
                    }
                    tmp.push({
                        id: el.id,
                        name: el.title,
                        val: el.id,
                        type: el.consum,
                        color: el.color,
                        size: el.size,
                        count: 1,
                        photo,
                        photopath,
                        rck: el.rck,
                    });
                })
            );
            setAvaibleConsumes(tmp);
        } catch (e) {
            console.log(e);
        }
    }, [company_id, user_id]);

    // [FIX 22, 23] fetchData обёрнут в useCallback, зависимости корректны
    const fetchData = useCallback(async () => {
        setLoading(true);

        const flattenItem = (el) => {
            // 1. Достаём sizes, НЕ мутируя el
            const elsizes = el.data.sizes ?? [];

            // 2. productId
            const productId =  el.nmID;

            // 3. Базовая часть карточки без sizes и без id — собираем явно
            //    (shallow: data — та же ссылка, но мы её больше не мутируем)
            const { sizes: _omit, ...dataWithoutSizes } = el.data;

            const baseCard = {
                ...el,
                data: dataWithoutSizes,
                id: productId,
            };

            return elsizes.map((size) => {
                // Для каждого размера — свой объект data (shallow копия + поля размера)
                const dataForSize = {
                    ...dataWithoutSizes,        // ← независимая копия на каждый размер
                    sizeTitle: size.title,
                    barcode: size.barcode,
                };
                if (size.vendorCode) dataForSize.vendorCode = size.vendorCode;

                const obj = {
                    ...baseCard,
                    id: `${productId};${size.barcode}`,
                    data: dataForSize,
                    size: {
                        ...size,
                    },
                };


                return obj;
            });
        };

        let res = await get("tech_task/getClientTechTasks", {uid: user_id})
        setData(res);

        let resp = await get("custom_product/getOnCli", { cid: user_id });

        const products = resp.flatMap((el) => flattenItem(el));
        setAvaibleProducts(products)

        await fetchServices();
        setLoading(false);
    }, [user_id, company_id, fetchServices]);

    

    // [FIX 23] useEffect с корректными зависимостями
    useEffect(() => {
        fetchData();
    }, [fetchData]);

    useEffect(() => {
        if (data.length > 0) {
            let c = 0
            for (let item of data) {
                if (item.version) {
                    let tmp = Number(item.version.split('_')[1])
                    if (tmp > c) {
                        c = tmp
                    }
                }
            }
            setNextVersion(`TZ_${c+1}`)
        }
        else {
            setNextVersion("TZ_1")
        }
    }, [data]);

    const filteredData = useMemo(() => {
        if (!checked || !filter) {
            return data;
        }

        const query = filter.toLowerCase();

        return data.filter((el) => {
            const active = filterFields;

            const matchesTitle =
                active.title.active &&
                ((el.main?.data?.title && String(el.main.data.title).toLowerCase().includes(query)) ||
                    (el.wb?.data?.title && String(el.wb.data.title).toLowerCase().includes(query)) ||
                    (el.ozon?.data?.title && String(el.ozon.data.title).toLowerCase().includes(query)));

            const matchesBrand =
                active.brand.active &&
                ((el.main?.data?.brand && String(el.main.data.brand).toLowerCase().includes(query)) ||
                    (el.wb?.data?.brand && String(el.wb.data.brand).toLowerCase().includes(query)) ||
                    (el.ozon?.data?.brand && String(el.ozon.data.brand).toLowerCase().includes(query)));

            const matchesVendorCode =
                active.vendorCode.active &&
                ((el.main?.data?.vendorCode && String(el.main.data.vendorCode).toLowerCase().includes(query)) ||
                    (el.wb?.data?.vendorCode && String(el.wb.data.vendorCode).toLowerCase().includes(query)) ||
                    (el.ozon?.data?.vendorCode && String(el.ozon.data.vendorCode).toLowerCase().includes(query)));

            const matchesBarcode =
                active.barcode.active &&
                ((el.main?.size?.barcodes?.some((bel) => String(bel).toLowerCase().includes(query))) ||
                    el.wb?.size?.barcodes?.some((bel) => String(bel).toLowerCase().includes(query)) ||
                    el.ozon?.size?.barcodes?.some((bel) => String(bel).toLowerCase().includes(query)));

            return matchesTitle || matchesBrand || matchesVendorCode || matchesBarcode;
        });
    }, [data, checked, filter, filterFields]);

    const rows = useMemo(() => {
        const result = [];
        for (let i = 0; i < filteredData.length; i += ITEMS_PER_ROW) {
            result.push(filteredData.slice(i, i + ITEMS_PER_ROW));
        }
        return result;
    }, [filteredData]);

    const rowVirtualizer = useVirtualizer({
        count: rows.length,
        getScrollElement: () => parentRef.current,
        estimateSize: () => ROW_HEIGHT,
        overscan: 5,
        // [FIX 14] стабильный ключ для виртуализатора
        getItemKey: (index) => {
            const row = rows[index];
            if (!row || row.length === 0) return `row-${index}`;
            return `row-${row.map((it) => it.id).join("-")}`;
        },
    });

    const saveTechTask = async (obj) => {
        if (obj.id) {
            await post("tech_task/update", {...obj, client_id: user_id})
        }
        else {
            await post("tech_task/create", {...obj, client_id: user_id})
        }
        setEdit(undefined)
        fetchData()
    }

    if (loading) {
        return <Loading />;
    }

    if (edit !== undefined) {
        return (
            <div className="custom-scrollbar" style={{ height: "100%", overflow: "auto", width: "100%" }}>
                <TeckTaskSettings
                    // @ts-ignore
                    item={edit}
                    services={services}
                    inServices={edit.services}
                    avaiblePackage={avaiblePackage}
                    avaibleConsumes={avaibleConsumes}
                    avaibleProducts={avaibleProducts}
                    goToPrevPage={() => {setEdit(undefined)}}
                    onSave={(obj) => {saveTechTask(obj)}}
                />
            </div>
        );
    }

    return (
        <Box sx={{ height: "100%" }}>
            <div
                style={{
                    height: "5%",
                    display: "flex",
                    width: "100%",
                    padding: "calc(2% - 5px) 1% 1% 1%",
                    alignItems: "center",
                    justifyContent: "space-between",
                }}
            >
                <div style={{ display: "flex", flexDirection: "row", alignItems: "center" }}>
                    <ClassicSearch
                        setChecked={setChecked}
                        setFilter={setFilter}
                        checked={checked}
                        // @ts-ignore
                        fields={filterFields}
                        // @ts-ignore
                        setFields={setFilterFields}
                    />
                </div>
                <div style={{ display: "flex", alignItems: "center", gap: "20px" }}>
                    <Box
                        sx={{
                            zIndex: 10,
                            display: "flex",
                            flexDirection: "column",
                            backgroundColor: "rgba(255, 255, 255, 0.5)",
                            padding: "15px 20px",
                            borderRadius: "10px",
                            minWidth: "250px",
                            height: "36px",
                            justifyContent: "center",
                        }}
                    >
                        {loading ? (
                            <Loading />
                        ) : (
                            <Box
                                sx={{
                                    display: "flex",
                                    gap: "20px",
                                    alignItems: "center",
                                    flexDirection: "row",
                                    justifyContent: "space-around",
                                }}
                            >
                                <Typography sx={{ fontSize: "12pt", whiteSpace: "nowrap" }}>
                                    Технических заданий: {data.length} шт.
                                </Typography>
                            </Box>
                        )}
                    </Box>
                    <IconButton
                        onClick={() => {
                            setEdit({version: nextVersion});
                        }}
                        sx={{
                            position: "relative",
                            backgroundColor: "#078476",
                            borderRadius: "50%",
                            height: "30px",
                            width: "30px",
                        }}
                        disableRipple
                    >
                        <AddIcon
                            sx={{
                                color: "white",
                                transition: "all 0.3s ease",
                                position: "relative",
                                "&:hover": hoverStyleTransformOnly,
                            }}
                        />
                    </IconButton>
                </div>
            </div>
            <div
                ref={parentRef}
                className="custom-scrollbar"
                style={{
                    height: "calc(100% - 60px)",
                    overflow: "auto",
                    width: "100%",
                    borderRadius: "10px",
                    marginTop: "1%",
                }}
            >
                <div
                    style={{
                        height: rowVirtualizer.getTotalSize(),
                        width: "98%",
                        margin: "0 1%",
                        position: "relative",
                    }}
                >
                    {rowVirtualizer.getVirtualItems().map((vi) => {
                        const rowItems = rows[vi.index];
                        return (
                            <div
                                key={vi.key}
                                style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    width: "100%",
                                    height: ROW_HEIGHT,
                                    transform: `translateY(${vi.start}px)`,
                                    display: "flex",
                                    gap: "1%",
                                    boxSizing: "border-box",
                                }}
                            >
                                {rowItems.map((item) => (
                                    <div key={item.id} style={{ width: "33%", height: "100%" }}>
                                        <TeckTaskCard 
                                            // @ts-ignore
                                            item={item} 
                                            onEdit={(obj) => setEdit(obj)}
                                        />
                                    </div>
                                ))}
                            </div>
                        );
                    })}
                </div>
            </div>
        </Box>
    );
}

export const TeckTaskCard = memo(function TeckTaskCard({ 
    // @ts-ignore   
    item,
    // @ts-ignore   
    onEdit 
}) {
    // [FIX 17] Безопасное имя + ключи для тегов
    const safeName = item?.name ? String(item.name).toUpperCase() : "";
    const tags = Array.isArray(item?.tags) ? item.tags : [];
    const services = Array.isArray(item?.services) ? item.services : [];

    return (
        <div
            style={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                borderRadius: "10px",
                backgroundColor: "#F5F9FA",
                overflow: "hidden",
                padding: "1% 1% 1% 5%",
            }}
        >
            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between" }}>
                <Typography
                    sx={{
                        fontSize: `16pt`, // [FIX 34]
                        color: buttonColor,
                        lineHeight: `18pt`,
                        fontWeight: "bold",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "-webkit-box",
                        WebkitLineClamp: 1,
                        WebkitBoxOrient: "vertical",
                    }}
                >
                    {safeName}
                </Typography>
                <IconButton disableRipple onClick={() => {onEdit(item)}} sx={{ transition: "all 0.3s ease", "&:hover": hoverStyle }}>
                    <SettingsIcon sx={{ color: buttonColor }} />
                </IconButton>
            </div>
            <div style={{ height: "calc( 24pt + 10px)", display: "flex", flexDirection: "row", alignItems: "center", flexWrap: 'wrap'}}>
                {/* [FIX 29] добавлен key для тегов */}
                {tags.map((tag) => (
                    <div
                        key={tag}
                        style={{
                            backgroundColor: iconColor,
                            borderRadius: "12px",
                            padding: "5px 10px 5px 10px",
                            margin: "0 10px 0 0",
                        }}
                    >
                        <Typography sx={{ fontSize: '10pt', color: buttonColor, lineHeight: `12pt` }}>
                            {tag}
                        </Typography>
                    </div>
                ))}
                {tags.length === 0 &&  
                    <div style={{height: '100%', display: 'flex', flexDirection: 'column', justifyContent: 'center'}}>
                        <Typography sx={{ fontSize: '10pt', color: 'gray', lineHeight: `12pt` }}>
                            Теги не указаны
                        </Typography>
                    </div>
                }
            </div>
            <div style={{ display: "flex", flexDirection: "row" }}>
                <Typography sx={{ fontSize: `14pt`, color: "gray", lineHeight: `16pt`, mt: "10px", mb: "10px", mr: "3px" }}>
                    Услуги
                </Typography>
                <Typography sx={{ fontSize: `14pt`, color: buttonColor, fontWeight: "bold", lineHeight: `16pt`, mt: "10px", mb: "10px" }}>
                    {services.length}
                </Typography>
            </div>
            {/* <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    height: `calc( (${FONT.cardBody}px + 8px) * ${SERVICE_SHOW_COUNT + 1} )`,
                }}
            >
                {services.slice(0, SERVICE_SHOW_COUNT).map((serv, idx) => (
                    <Typography
                        key={`${serv?.name ?? "serv"}-${idx}`} // [FIX 29] key для списка услуг
                        sx={{ fontSize: `${FONT.cardBody}px`, color: "gray", lineHeight: `${FONT.cardBody}px`, mb: "8px" }}
                    >
                        {serv?.name}
                    </Typography>
                ))}
                {services.length > SERVICE_SHOW_COUNT && (
                    <Typography sx={{ fontSize: `${FONT.cardBody}px`, color: "gray", lineHeight: `${FONT.cardBody}px`, mb: "8px" }}>
                        {`И еще ${services.length - SERVICE_SHOW_COUNT}...`}
                    </Typography>
                )}
            </div> */}
            {/* <div style={{ height: "36px", display: "flex", flexDirection: "row", marginTop: "8px" }}>
                <Typography sx={{ fontSize: `${FONT.cardBody}px`, lineHeight: `${FONT.cardBody + 2}px`, fontWeight: "bold", mr: "3px" }}>Комментарий</Typography>
                <Typography
                    sx={{
                        fontSize: `${FONT.cardBody}px`,
                        color: "gray",
                        lineHeight: `${FONT.cardBody + 2}px`,
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        display: "-webkit-box",
                        WebkitLineClamp: 2,
                        WebkitBoxOrient: "vertical",
                    }}
                >
                    {text}
                </Typography>
            </div> */}
        </div>
    );
});

const BaseCard = memo(function BaseCard({
    // @ts-ignore
    leftContent,
    // @ts-ignore
    rightContent,
    // @ts-ignore
    leftWidth = "40%",
    // @ts-ignore
    rightWidth = "60%",
    // @ts-ignore
    leftBackground = "#F5F9FA",
    // @ts-ignore
    rightBackground = "rgba(255, 255, 255, 0.5)",
}) {
    return (
        <div
            style={{
                width: "96%",
                display: "flex",
                flexDirection: "row",
                alignItems: "stretch",
                margin: "0% 2% 0% 2%",
                borderRadius: "10px",
                backgroundColor: "rgba(255, 255, 255, 0.0)",
                overflow: "hidden",
            }}
        >
            {leftContent && (
                <div
                    style={{
                        width: leftWidth,
                        backgroundColor: leftBackground,
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "space-between",
                        padding: "1%",
                    }}
                >
                    {leftContent}
                </div>
            )}
            {rightContent && (
                <div
                    style={{
                        width: rightWidth,
                        backgroundColor: rightBackground,
                        padding: "1%",
                        display: "flex",
                        flexDirection: "row",
                        alignItems: "center",
                    }}
                >
                    {rightContent}
                </div>
            )}
        </div>
    );
});

// ============================================================
// [FIX 1, 2, 3, 4, 7, 8, 9, 13] Универсальная таблица расходников
// ============================================================
/**
 * Универсальный компонент таблицы расходников.
 * Заменяет 4 почти одинаковых блока:
 *  - Упаковка товара (клиент)  → type="pack",      field="packcli",         source="consumes"
 *  - Упаковка товара (фф)      → type="__ff__",    field="packff",          source="package"
 *  - Комплектация товара       → type="other",     field="consumabels",     source="consumes"
 *  - Дополнительные расходники → type="additional",field="addit_consumabels",source="consumes"
 */
const ConsumablesTable = memo(function ConsumablesTable({
    // @ts-ignore
    title,
    // @ts-ignore
    source,          // "consumes" | "package"
    // @ts-ignore
    type,            // фильтр по типу
    // @ts-ignore
    field,           // поле в data: packcli | packff | consumabels | addit_consumabels
    // @ts-ignore
    data,            // объект с полями
    // @ts-ignore
    onDataChange,    // функция обновления data
    // @ts-ignore
    avaibleConsumes,
    // @ts-ignore
    avaiblePackage,
}) {
    // [FIX 4] локальные обработчики обёрнуты в useCallback
    const handleSelect = useCallback(
        (selected) => {
            const pool = source === "package" ? avaiblePackage : avaibleConsumes;
            const filtered = pool.filter((el) => {
                if (source === "package") return selected.includes(el.id);
                return selected.includes(el.id) && el.type === type;
            });

            // [FIX 8, 9] без JSON.parse(JSON.stringify) и без _.set — иммутабельно
            const current = Array.isArray(data[field]) ? data[field] : [];
            const next = filtered.map((el) => {
                const existing = current.find((it) => it.id === el.id);
                return existing ? { ...existing } : { ...el };
            });

            onDataChange({ ...data, [field]: next });
        },
        [source, avaiblePackage, avaibleConsumes, type, data, field, onDataChange]
    );

    const handleCountChange = useCallback(
        (e) => {
            const pool = source === "package" ? avaiblePackage : avaibleConsumes;
            const current = Array.isArray(data[field]) ? data[field] : [];
            const idx = current.findIndex((it) => it.id === e.row.id);

            let next;
            if (idx > -1) {
                next = current.map((it, i) => (i === idx ? { ...it, count: e.count } : it));
            } else {
                const fromPool = pool.find((fel) => fel.id === e.row.id);
                next = fromPool ? [...current, { ...fromPool, count: e.count }] : current;
            }

            onDataChange({ ...data, [field]: next });
        },
        [source, avaiblePackage, avaibleConsumes, data, field, onDataChange]
    );

    // [FIX 13] вычисление данных вынесено в useMemo
    const [checkedLocal, setCheckedLocal] = useState(false);
    const [filterLocal, setFilterLocal] = useState("");
    const [filterFieldsLocal, setFilterFieldsLocal] = useState({ title: { name: "Название", active: true } });

    const ds = useMemo(() => getDataSource(source === "package" ? "packageSelect" : "consumeSelect"), [source]);

    const tableData = useMemo(() => {
        const pool = source === "package" ? avaiblePackage : avaibleConsumes;
        const current = Array.isArray(data[field]) ? data[field] : [];

        let list = pool
            .filter((el) => (source === "package" ? true : el.type === type))
            .map((cel) => {
                const found = current.find((fel) => fel.id === cel.id);
                return found ? { ...cel, count: found.count } : { ...cel };
            })
            .sort((a, b) => a.name.localeCompare(b.name));

        if (checkedLocal && filterLocal) {
            const tf = filterLocal.toLowerCase();
            list = list.filter(
                (el) =>
                    filterFieldsLocal.title.active &&
                    el.name &&
                    String(el.name).toLowerCase().includes(tf)
            );
        }

        return list;
    }, [source, avaiblePackage, avaibleConsumes, type, data, field, checkedLocal, filterLocal, filterFieldsLocal]);

    const selectedIds = useMemo(
        () => (Array.isArray(data[field]) ? data[field].map((el) => el.id) : []),
        [data, field]
    );

    return (
        <BaseCard
            // @ts-ignore
            rightWidth={"100%"}
            leftContent={undefined}
            rightContent={
                <div style={{ width: "100%" }}>
                    <div
                        style={{
                            width: "100%",
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "10px",
                        }}
                    >
                        <ClassicSearch
                            setChecked={setCheckedLocal}
                            setFilter={setFilterLocal}
                            checked={checkedLocal}
                            // @ts-ignore
                            customWidth={"20%"}
                        />
                        <Typography sx={{ color: "gray" }}>{title}</Typography>
                    </div>
                    <ReportTable
                        ds={ds}
                        data={tableData}
                        onSelect={handleSelect}
                        onFormatterChange={handleCountChange}
                        inputSelected={selectedIds}
                    />
                </div>
            }
        />
    );
});

// @ts-ignore
export const TeckTaskSettings = memo(function TeckTaskSettings({
    // @ts-ignore
    item,
    // @ts-ignore
    services,
    // @ts-ignore
    avaiblePackage,
    // @ts-ignore
    avaibleConsumes,
    // @ts-ignore
    avaibleProducts,
    // @ts-ignore
    goToPrevPage,
    // @ts-ignore
    onSave,
}) {
    /** @type {[any, Function]} */
    const [TechTask, setTechTask] = useState(undefined);
    /** @type {[any, Function]} */
    const [data, setData] = useState({
        packff: [],
        packcli: [],
        consumabels: [],
        addit_consumabels: [],
        other: [],
    });

    // Настройки фильтра
    const [checked, setChecked] = useState(false);
    /** @type {[any, Function]} */
    const [filter, setFilter] = useState(null);
    /** @type {[any, Function]} */
    const [filterFields, setFilterFields] = useState({
        title: { name: "Название", active: true },
    });

    // Настройки фильтра услуг
    const [checkedServ, setCheckedServ] = useState(false);
    /** @type {[any, Function]} */
    const [filterServ, setFilterServ] = useState("");
    /** @type {[any, Function]} */
    const [filterFieldsServ, setFilterFieldsServ] = useState({
        title: { name: "Название", active: true },
    });
    /** @type {[any, Function]} */
    const [selServices, setSelServices] = useState([]);

    /** @type {[any, Function]} */
    const [price, setprice] = useState(0);
    
    /** @type {any} */
    const TAGS = [
        {
            name: "Без направления", 
            blockedWith: ["WB", "OZON", "Другие направления"],
            info: "Отмечайте этим тегом технические задания, которые применяются при поставке товара на склад без известного заранее направления отгрузки"
        },
        {
            name: "Для отгрузки", 
            blockedWith: ["Без направления"],
            info: "Отмечайте этим тегом технические задания, которые применяются к сделкам на отгрузку, и не будут хранится на складе"
        },
        {
            name: "Для хранения", 
            blockedWith: ["Для отгрузки"],
            info: "Отмечайте этим тегом технические задания, которые применяются к сделкам на хранение"
        },
        {
            name: "WB", 
            blockedWith: [],
            info: "Приеняйте этот тег к техническим заданиям, которые применяются непосредственно перед отгрузкой на маркетплейс WB"
        },
        {
            name: "OZON", 
            blockedWith: [],
            info: "Приеняйте этот тег к техническим заданиям, которые применяются непосредственно перед отгрузкой на маркетплейс WB"
        },
        {
            name: "Другие направления", 
            blockedWith: ["FBS"],
            info: "Приеняйте этот тег к техническим заданиям, которые применяются непосредственно перед отгрузкой на любое направление кроме поддерживаемых маркетплесов"
        },
        {
            name: "FBS", 
            blockedWith: [],
            info: "Приеняйте этот тег к техническим заданиям, которые используются для обработки заказов FBS. Применение данного тега без указания конкретного маркета, не имеет смысла."
        }
    ]

    /** @type {[any, Function]} */
    const [selTags, setSelTags] = useState([]);
    // Выбранные баркоды ТЗ (строки)
    /** @type {[any, Function]} */
    const [selBarcodes, setSelBarcodes] = useState([]);

    // Открыт ли дровер
    const [drawerOpen, setDrawerOpen] = useState(false);

    // Поиск в дровере
    const [productSearchChecked, setProductSearchChecked] = useState(false);
    /** @type {[any, Function]} */
    const [productSearch, setProductSearch] = useState("");

    const otherServiceDS = useMemo(() => getDataSource("otherServiceDS"), []);

    const { showNotification } = useLocalNotifications();

    // [FIX 7] Два useEffect объединены в один, checkPhoto вынесена в утилиту
    useEffect(() => {
        setTechTask(item);

        if (!item?.services || !item.tags) return;

        const sourceServices = JSON.parse(JSON.stringify(item?.services)); // оставлено для глубокого клонирования входящих данных (пункт 8 касается внутренних обновлений)
        const tmp = { packff: [], packcli: [], consumabels: [], addit_consumabels: [], other: [] };

        const idxp1 = sourceServices.findIndex((el) => el.name === "Упаковка товара (фф)");
        if (idxp1 > -1) tmp.packff = sourceServices[idxp1].data.packff;

        const idxp2 = sourceServices.findIndex((el) => el.name === "Упаковка товара (клиент)");
        if (idxp2 > -1) tmp.packcli = sourceServices[idxp2].data.packcli;

        const idxCons1 = sourceServices.findIndex((el) => el.name === "Комплектация товара");
        if (idxCons1 > -1) tmp.consumabels = sourceServices[idxCons1].data.consumes;

        const idxCons2 = sourceServices.findIndex((el) => el.name === "Дополнительные расходники");
        if (idxCons2 > -1) tmp.addit_consumabels = sourceServices[idxCons2].data.addit_cons;

        let cancelled = false;
        (async () => {
            await hydratePhotos(tmp);
            if (cancelled) return;
            setData(tmp);
            setSelServices(JSON.parse(JSON.stringify(item?.services)));
            setSelTags(item?.tags.map((el) => {return {name: el}}))
            setSelBarcodes(
                Array.isArray(item?.barcodes) ? [...item.barcodes] : []
            );

        })();

        return () => {
            cancelled = true;
        };
    }, [item]);

    // [FIX 4] isSelected и changeServices обёрнуты в useCallback
    const isSelected = useCallback(
        (name) => selServices?.some((el) => el.name === name) ?? false,
        [selServices]
    );

    const changeServices = useCallback((name) => {
        setSelServices((prev) => {
            const tmp = [...prev];
            const idx = tmp.findIndex((el) => el.name === name);
            if (idx > -1) {
                tmp.splice(idx, 1);
            } else {
                tmp.push({ name, data: { count: 1 } });
            }
            return tmp;
        });
    }, []);

    // [FIX 3] getAllServices обёрнут в useMemo, возвращает JSX
    const allServicesContent = useMemo(() => {
        const base = Array.isArray(services) ? services : [];
        const filterText = (filterServ || "").toLowerCase();

        const selectedNames = new Set((selServices || []).map((el) => el.name));
        const selectedItems = (selServices || []).map((el) => base.find((s) => s.name === el.name) || el);
        const otherItems = base.filter((el) => !selectedNames.has(el.name));

        let all = [...selectedItems, ...otherItems].sort((a, b) => a.name.localeCompare(b.name));

        if (filterText) {
            all = all.filter(
                (el) =>
                    filterFieldsServ.title.active &&
                    el.name &&
                    String(el.name).toLowerCase().includes(filterText)
            );
        }

        if (all.length === 0) {
            return <div style={{ padding: "10px", color: "#999", fontSize: "14px" }}>Пусто</div>;
        }

        return (
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    rowGap: "10px",
                    columnGap: "1.2%",
                    flexWrap: "wrap",
                    padding: "5px",
                }}
            >
                {all.map((el) => {
                    const selected = isSelected(el.name);
                    return (
                        <div
                            key={el.id || el.name}
                            onClick={() => changeServices(el.name)}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                                padding: "10px 15px",
                                backgroundColor: "white",
                                borderRadius: "8px",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                                border: selected ? "1px solid #208f84" : "1px solid #e0e0e0",
                                transition: "all 0.2s ease",
                                width: "19%",
                                position: "relative",
                                cursor: "pointer",
                                userSelect: "none",
                            }}
                        >
                            <div
                                style={{
                                    width: "12px",
                                    height: "12px",
                                    borderRadius: "50%",
                                    backgroundColor: selected ? "#208f84" : "#ffffff",
                                    border: selected ? "1px solid #208f84" : "1px solid #cfcfcf",
                                    flexShrink: 0,
                                }}
                            />
                            <div style={{ width: "180px" }}>
                                <Typography
                                    style={{
                                        fontWeight: "600",
                                        fontSize: "12px",
                                        color: "#2c3e50",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                    }}
                                >
                                    {el.name}
                                </Typography>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }, [services, selServices, filterServ, filterFieldsServ, isSelected, changeServices]);

    // [FIX 2, 4] единый обработчик для "other"-услуг
    const editNumValueOther = useCallback((e) => {
        setSelServices((prev) => {
            const idx = prev.findIndex((it) => it.name === e.row.id);
            if (idx === -1) return prev;
            return prev.map((it, i) =>
                i === idx ? { ...it, data: { ...it.data, count: e.count } } : it
            );
        });
    }, []);

    // [FIX 2] единый onDataChange для ConsumablesTable
    const handleDataChange = useCallback((next) => {
        setData(next);
    }, []);

    const otherServices = (selServices || []).filter(
        (fel) =>
            fel.name !== "Комплектация товара" &&
            fel.name !== "Упаковка товара (фф)" &&
            fel.name !== "Упаковка товара (клиент)" &&
            fel.name !== "Дополнительные расходники"
    );

    // Является ли тег выбранным
    const isTagSelected = useCallback(
        (name) => (selTags || []).some((el) => el.name === name),
        [selTags]
    );

    // Проверка: заблокирован ли тег `name` выбранными тегами
    // Возвращает { blocked: true, by: "WB" } или { blocked: false }
    const getTagBlockInfo = useCallback(
        (name) => {
            const selectedNames = new Set((selTags || []).map((el) => el.name));
            // 1) Прямая проверка: у выбранного тега в blockedWith есть name
            for (const tag of TAGS) {
                if (!selectedNames.has(tag.name)) continue;
                if (tag.blockedWith.includes(name)) {
                    return { blocked: true, by: tag.name, direction: "selectedBlocksCandidate" };
                }
            }
            // 2) Обратная проверка: у кандидата в blockedWith есть выбранный тег
            const candidate = TAGS.find((t) => t.name === name);
            if (candidate) {
                for (const blockedName of candidate.blockedWith) {
                    if (selectedNames.has(blockedName)) {
                        return { blocked: true, by: blockedName, direction: "candidateBlocksSelected" };
                    }
                }
            }
            return { blocked: false };
        },
        [selTags, TAGS]
    );

    const changeTags = useCallback(
        (name) => {
            const alreadySelected = (selTags || []).some((el) => el.name === name);

            // Снятие — всегда разрешено
            if (alreadySelected) {
                setSelTags((prev) => prev.filter((el) => el.name !== name));
                return;
            }

            // Проверка блокировок
            const info = getTagBlockInfo(name);
            if (info.blocked) {
                // Формулировка по ТЗ: "тег A, нельзя выбрать, когда выбран тег Б"
                // info.by — это тот тег, который мешает, name — тот, который пытаемся выбрать
                showNotification({ 
                    id: 'uploadCPImageOk', 
                    type: 'warning', 
                    message: `Тег «${name}», нельзя выбрать, когда выбран тег «${info.by}»`
                });
                return;
            }

            setSelTags((prev) => [...prev, { name }]);
        },
        [selTags, getTagBlockInfo, showNotification]
    );

    const allTagsContent = useMemo(() => {
        // Берём TAGS как есть — он задаёт порядок.
        // Никакой сортировки, никакого поднятия выбранных наверх.
        const all = TAGS;

        if (all.length === 0) {
            return (
                <div style={{ padding: "10px", color: "#999", fontSize: "14px" }}>
                    Пусто
                </div>
            );
        }

        return (
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    rowGap: "10px",
                    columnGap: "1.2%",
                    flexWrap: "wrap",
                    padding: "5px",
                    width: '100%'
                }}
            >
                {all.map((el) => {
                    const selected = isTagSelected(el.name);
                    const blockInfo = selected ? { blocked: false } : getTagBlockInfo(el.name);
                    const blocked = blockInfo.blocked;

                    return (
                        <Tooltip
                            key={el.name}
                            title={
                                blocked
                                    ? `Нельзя выбрать, когда выбран тег «${blockInfo.by}»`
                                    : el.info
                            }
                            arrow
                        >
                            <div
                                onClick={() => changeTags(el.name)}
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    gap: "10px",
                                    padding: "10px 15px",
                                    backgroundColor: blocked ? "#f4f4f4" : "white",
                                    borderRadius: "8px",
                                    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                                    border: selected
                                        ? "1px solid #208f84"
                                        : blocked
                                            ? "1px dashed #cfcfcf"
                                            : "1px solid #e0e0e0",
                                    transition: "all 0.2s ease",
                                    width: "19%",
                                    position: "relative",
                                    cursor: blocked ? "not-allowed" : "pointer",
                                    userSelect: "none",
                                    opacity: blocked ? 0.6 : 1,
                                }}
                            >
                                <div
                                    style={{
                                        width: "12px",
                                        height: "12px",
                                        borderRadius: "50%",
                                        backgroundColor: selected
                                            ? "#208f84"
                                            : "#ffffff",
                                        border: selected
                                            ? "1px solid #208f84"
                                            : "1px solid #cfcfcf",
                                        flexShrink: 0,
                                    }}
                                />
                                <div style={{ width: "calc( 100% - 12px)" }}>
                                    <Typography
                                        style={{
                                            fontWeight: "600",
                                            fontSize: "12px",
                                            color: blocked ? "#999" : "#2c3e50",
                                            whiteSpace: "nowrap",
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                        }}
                                    >
                                        {el.name}
                                    </Typography>
                                </div>
                            </div>
                        </Tooltip>
                    );
                })}
            </div>
        );
    }, [selTags, TAGS, isTagSelected, getTagBlockInfo, changeTags]);

    const showErrorNotification = (type) => {
        let message = ""

        switch (type) {
            case "packff_empty":
                message = "Не указаны упаковки товара (фф)"
                break
            case "packff_count":
                message = "Количество в упаковке товара (фф) должно быть больше 0"
                break
            case "packcli_empty":
                message = "Не указаны упаковки товара (клиент)"
                break
            case "packcli_count":
                message = "Количество в упаковке товара (клиент) должно быть больше 0"
                break
            case "consum_empty":
                message = "Не указаны расходники для комплектации"
                break
            case "consum_count":
                message = "Количество расходников для комплектации должно быть больше 0"
                break
            case "addit_consum_empty":
                message = "Не указаны дополнительные расходники"
                break
            case "addit_consum_count":
                message = "Количество дополнительных расходников должно быть больше 0"
                break
            case "service_empty":
                message = "Количество для 'Другие услуги' должно быть больше 0"
                break
            default:
                message = "Ошибка при заполнении ТЗ"
        }

        showNotification({
            id: 'fieldsErr',
            type: 'error',
            message
        })
    }

    const save = () => {
        // Работаем только с копиями. Нельзя менять selServices во время валидации,
        // иначе сравнение с исходным inServices будет показывать ложные изменения.
        const tmp = JSON.parse(JSON.stringify(data))
        const servicesToSave = JSON.parse(JSON.stringify(selServices))
        const originalServices = JSON.parse(JSON.stringify(item.services || []))
        let errorType = null

        const setError = (type) => {
            if (!errorType) errorType = type
        }

        // --- Блок валидации ---
        const idxP1 = servicesToSave.findIndex((el) => el.name === "Упаковка товара (фф)")
        if (idxP1 > -1) {
            if (tmp.packff.length < 1) setError("packff_empty")
            tmp.packff.forEach((el) => {
                if (el.count < 1) setError("packff_count")
            })
            if (!errorType) {
                servicesToSave[idxP1].data = { packff: tmp.packff }
            }
        }

        const idxP2 = servicesToSave.findIndex((el) => el.name === "Упаковка товара (клиент)")
        if (idxP2 > -1) {
            if (tmp.packcli.length < 1) setError("packcli_empty")
            tmp.packcli.forEach((el) => {
                if (el.count < 1) setError("packcli_count")
            })
            if (!errorType) {
                const packcli = tmp.packcli.map((el) => ({
                    ...el,
                    ...(el.photo ? { photo: el.photopath } : {})
                }))
                servicesToSave[idxP2].data = { packcli }
            }
        }

        const idxCons = servicesToSave.findIndex((el) => el.name === "Комплектация товара")
        if (idxCons > -1) {
            if (tmp.consumabels.length < 1) setError("consum_empty")
            tmp.consumabels.forEach((el) => {
                if (el.count < 1) setError("consum_count")
            })
            if (!errorType) {
                const consumes = tmp.consumabels.map((el) => ({
                    ...el,
                    ...(el.photo ? { photo: el.photopath } : {})
                }))
                servicesToSave[idxCons].data = { consumes }
            }
        }

        const idxAdditCons = servicesToSave.findIndex((el) => el.name === "Дополнительные расходники")
        if (idxAdditCons > -1) {
            if (tmp.addit_consumabels.length < 1) setError("addit_consum_empty")
            tmp.addit_consumabels.forEach((el) => {
                if (el.count < 1) setError("addit_consum_count")
            })
            if (!errorType) {
                const additCons = tmp.addit_consumabels.map((el) => ({
                    ...el,
                    ...(el.photo ? { photo: el.photopath } : {})
                }))
                servicesToSave[idxAdditCons].data = { addit_cons: additCons }
            }
        }

        servicesToSave
            .filter((fel) =>
                fel.name !== "Комплектация товара" &&
                fel.name !== "Упаковка товара (фф)" &&
                fel.name !== "Упаковка товара (клиент)" &&
                fel.name !== "Дополнительные расходники"
            )
            .forEach((el) => {
                if ((el.data?.count ?? 0) <= 0) setError("service_empty")
            })
        // --- Конец блока валидации ---

        if (!errorType) {
            onSave(
                {
                    id: item.id || undefined,
                    text: TechTask.text,
                    services: servicesToSave,
                    name: TechTask.name,
                    barcodes: selBarcodes.map((b) => String(b)),
                    tags: selTags.map((el) => el.name),
                    settings: [],
                    version: TechTask.version
                }
            )
        } else {
            showErrorNotification(errorType)
        }
    }

    // Изменение названия ТЗ
    const changeName = useCallback((value) => {
        setTechTask((prev) => {
            if (!prev) return prev;
            // TextInputDesign может отдавать как строку, так и событие — нормализуем
            const next = typeof value === "string" ? value : value?.target?.value ?? "";
            return { ...prev, name: next };
        });
    }, []);

    // Изменение комментария
    const changeText = useCallback((value) => {
        setTechTask((prev) => {
            if (!prev) return prev;
            const next = typeof value === "string" ? value : value?.target?.value ?? "";
            return { ...prev, text: next };
        });
    }, []);

    // Добавить один баркод
    const addBarcode = useCallback((barcode) => {
        setSelBarcodes((prev) => {
            if (prev.some((b) => String(b) === String(barcode))) return prev;
            return [...prev, barcode];
        });
    }, []);

    // Удалить один баркод
    const removeBarcode = useCallback((barcode) => {
        setSelBarcodes((prev) => prev.filter((b) => String(b) !== String(barcode)));
    }, []);

    // Добавить все отфильтрованные (видимые) баркоды
    const addAllBarcodes = useCallback((barcodes) => {
        setSelBarcodes((prev) => {
            const existing = new Set(prev.map((b) => String(b)));
            const toAdd = barcodes.filter((b) => !existing.has(String(b)));
            return [...prev, ...toAdd];
        });
    }, []);

    const searchLower = (productSearch || "").toLowerCase();

    // Товары, которых ещё нет в selBarcodes
    const availableProducts = useMemo(() => {
        const list = Array.isArray(avaibleProducts) ? avaibleProducts : [];
        const existing = new Set((selBarcodes || []).map((b) => String(b)));

        let result = list.filter((p) => {
            const bc = p?.size?.barcode ?? p?.data?.barcode;
            if (bc === undefined || bc === null) return false;
            return !existing.has(String(bc));
        });

        if (productSearchChecked && searchLower) {
            result = result.filter((p) => {
                const fields = [
                    p?.data?.title,
                    p?.data?.vendorCode,
                    p?.size?.vendorCode,
                    p?.size?.barcode,
                    p?.data?.brand,
                ];
                return fields.some(
                    (f) => f && String(f).toLowerCase().includes(searchLower)
                );
            });
        }

        return result;
    }, [avaibleProducts, selBarcodes, searchLower, productSearchChecked]);

    const selectedBarcodesContent = useMemo(() => {
        const list = Array.isArray(selBarcodes) ? selBarcodes : [];

        if (list.length === 0) {
            return (
                <div style={{ padding: "10px", color: "#999", fontSize: "14px" }}>
                    Товары не добавлены
                </div>
            );
        }

        // Подтягиваем инфу о товаре, чтобы показать его название рядом с баркодом
        const productsById = new Map(
            (avaibleProducts || []).map((p) => {
                const bc = p?.size?.barcode ?? p?.data?.barcode;
                return [String(bc), p];
            })
        );

        return (
            <div
                style={{
                    display: "flex",
                    flexDirection: "row",
                    rowGap: "10px",
                    columnGap: "1.2%",
                    flexWrap: "wrap",
                    padding: "5px",
                    width: "100%",
                }}
            >
                {list.map((bc) => {
                    const product = productsById.get(String(bc));
                    const title = product?.data?.title || product?.data?.vendorCode || "Товар";
                    return (
                        <div
                            key={String(bc)}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                                padding: "10px 15px",
                                backgroundColor: "white",
                                borderRadius: "8px",
                                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                                border: "1px solid #e0e0e0",
                                transition: "all 0.2s ease",
                                width: "19%",
                                position: "relative",
                                userSelect: "none",
                            }}
                        >
                            <div style={{ flex: 1, minWidth: 0 }}>
                                <Typography
                                    style={{
                                        fontWeight: "600",
                                        fontSize: "12px",
                                        color: "#2c3e50",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                    }}
                                >
                                    {title}
                                </Typography>
                                <Typography
                                    style={{
                                        fontSize: "11px",
                                        color: "#7a8a99",
                                        whiteSpace: "nowrap",
                                        overflow: "hidden",
                                        textOverflow: "ellipsis",
                                    }}
                                >
                                    {String(bc)}
                                </Typography>
                            </div>
                            <IconButton
                                size="small"
                                disableRipple
                                onClick={() => removeBarcode(bc)}
                                sx={{
                                    color: "#c0392b",
                                    transition: 'all 0.3s ease',
                                    "&:hover": hoverStyleTransformOnly,
                                }}
                            >
                                <DeleteIcon fontSize="small" />
                            </IconButton>
                        </div>
                    );
                })}
            </div>
        );
    }, [selBarcodes, avaibleProducts, removeBarcode]);

    const productsDrawer = (
        <Drawer
            anchor="right"
            open={drawerOpen}
            onClose={() => setDrawerOpen(false)}
            PaperProps={{ sx: { width: "50%", minWidth: 480 } }}
            keepMounted={false}
        >
            {drawerOpen && (
                <DrawerContent
                    // @ts-ignore
                    availableProducts={availableProducts}
                    addBarcode={addBarcode}
                    addAllBarcodes={addAllBarcodes}
                    productSearchChecked={productSearchChecked}
                    setProductSearchChecked={setProductSearchChecked}
                    productSearch={productSearch}
                    setProductSearch={setProductSearch}
                />
            )}
        </Drawer>
    );

    useEffect(() => {
        if (!drawerOpen) return;
        const id = requestAnimationFrame(() => {
            // ничего не делаем, просто форсим перерисовку
            // виртуализатор внутри DrawerContent сам разберётся через ResizeObserver
        });
        return () => cancelAnimationFrame(id);
    }, [drawerOpen]);

    if (!TechTask) {
        return <></>;
    }

    // [FIX 1] Определения блоков расходников через конфиг — вместо 4 копий JSX
    const consumableBlocks = [
        {
            name: "Упаковка товара (клиент)",
            source: "consumes",
            type: "pack",
            field: "packcli",
            title: "Упаковка товара (клиент)",
        },
        {
            name: "Упаковка товара (фф)",
            source: "package",
            type: "__ff__",
            field: "packff",
            title: "Упаковка товара (фф)",
        },
        {
            name: "Комплектация товара",
            source: "consumes",
            type: "other",
            field: "consumabels",
            title: "Комплектация товара",
        },
        {
            name: "Дополнительные расходники",
            source: "consumes",
            type: "additional",
            field: "addit_consumabels",
            title: "Дополнительные расходники",
        },
    ];    

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                gap: "30px",
                padding: "2%",
                width: "100%",
                boxSizing: "border-box",
            }}
        >

            <div style={{display: 'flex', flexDirection: 'row', width: '100%', justifyContent: 'space-between', padding: '0 2% 0 2%'}}>
                <CancelButton action={() => {goToPrevPage()}} text={"ВЕРНУТЬСЯ"}/>
                <OKButton action={() => {save()}} text={TechTask.id? "СОХРАНИТЬ": "СОЗДАТЬ"}/>
            </div>
            <BaseCard
                // @ts-ignore
                leftContent={
                    <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'space-around', gap: '60px'}}>
                        <TextInputDesign val={TechTask.name} title={"Название"} onChange={changeName}/>
                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between" }}>
                            <div style={{ width: "49%", display: "flex", flexDirection: "column", padding: "5px", backgroundColor: iconColor, borderRadius: "10px" }}>
                                <Typography sx={{ fontSize: `${FONT.cardPrice}px`, color: buttonColor, lineHeight: `${FONT.cardPrice}px` }}>{price} ₽</Typography>
                                <Typography sx={{ fontSize: `${FONT.cardBody}px`, color: "gray", lineHeight: `${FONT.cardBody}px` }}>за ед. товара</Typography>
                            </div>
                            <div style={{ width: "49%", display: "flex", flexDirection: "column", padding: "5px", backgroundColor: iconColor, borderRadius: "10px" }}>
                                <Typography sx={{ fontSize: `${FONT.cardPrice}px`, color: buttonColor, lineHeight: `${FONT.cardPrice}px` }}>{selBarcodes.length}</Typography>
                                <Typography sx={{ fontSize: `${FONT.cardBody}px`, color: "gray", lineHeight: `${FONT.cardBody}px` }}>товаров используют</Typography>
                            </div>
                        </div>
                    </div>
                }
                rightContent={
                    <MemoTextField
                        text={TechTask.text}
                        handleInputChange={changeText}
                        placeholder={"Комментарий для сотрудников"}
                        maxLength={1000}
                        editable={true}
                        rows={7}
                    />
                }
            />

            <BaseCard
                // @ts-ignore
                leftWidth={"0%"}
                rightWidth={"100%"}
                leftContent={undefined}
                rightContent={
                    <div
                        style={{
                            padding: "5px",
                            paddingLeft: "10px",
                            borderRadius: "10px",
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                        }}
                    >
                         <div
                            style={{
                                width: "100%",
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginBottom: "10px",
                            }}
                        >
                            <Typography sx={{ color: "gray" }}>Теги технического задания</Typography>
                        </div>
                        {allTagsContent}
                    </div>
                }
            />

            <BaseCard
                // @ts-ignore
                leftWidth={"0%"}
                rightWidth={"100%"}
                leftContent={undefined}
                rightContent={
                    <div
                        style={{
                            padding: "5px",
                            paddingLeft: "10px",
                            borderRadius: "10px",
                            opacity: 1,
                            width: "100%",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                        }}
                    >
                         <div
                            style={{
                                width: "100%",
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginBottom: "10px",
                            }}
                        >
                            <ClassicSearch
                                setChecked={setCheckedServ}
                                setFilter={setFilterServ}
                                checked={checkedServ}
                                // @ts-ignore
                                customWidth={"20%"}
                            />
                            <Typography sx={{ color: "gray" }}>Список услуг</Typography>
                        </div>
                        {allServicesContent}
                    </div>
                }
            />

            {/* [FIX 1] 4 одинаковых блока заменены на map по конфигу */}
            {consumableBlocks.map((block) => {
                const isActive = selServices?.findIndex((fel) => fel.name === block.name) > -1;
                if (!isActive) return null;
                return (
                    <ConsumablesTable
                        key={block.field}
                        // @ts-ignore
                        title={block.title}
                        source={block.source}
                        type={block.type}
                        field={block.field}
                        data={data}
                        onDataChange={handleDataChange}
                        avaibleConsumes={avaibleConsumes}
                        avaiblePackage={avaiblePackage}
                    />
                );
            })}

            {otherServices.length > 0 && (
                <BaseCard
                    // @ts-ignore
                    rightWidth={"100%"}
                    leftContent={undefined}
                    rightContent={
                        <div style={{ width: "100%" }}>
                            <div
                                style={{
                                    width: "100%",
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    marginBottom: "10px",
                                }}
                            >
                                <ClassicSearch
                                    setChecked={setChecked}
                                    setFilter={setFilter}
                                    checked={checked}
                                    // @ts-ignore
                                    customWidth={"20%"}
                                />
                                <Typography sx={{ color: "gray" }}>Другие услуги</Typography>
                            </div>
                            <ReportTable
                                ds={otherServiceDS}
                                data={
                                    !checked
                                        ? otherServices.map((el) => ({ ...el, id: el.name }))
                                        : otherServices
                                            .map((el) => ({ ...el, id: el.name }))
                                            .filter((el) => {
                                                const tf = (filter || "").toLowerCase();
                                                return (
                                                    filterFields.title.active &&
                                                    el.name &&
                                                    String(el.name).toLowerCase().includes(tf)
                                                );
                                            })
                                }
                                onFormatterChange={editNumValueOther}
                            />
                        </div>
                    }
                />
            )}

            <BaseCard
                // @ts-ignore
                rightWidth={"100%"}
                leftContent={undefined}
                rightContent={
                    <div style={{ width: "100%" }}>
                        <div
                            style={{
                                width: "100%",
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                                alignItems: "center",
                                marginBottom: "10px",
                            }}
                        >
                            <Typography sx={{ color: "gray" }}>Товары</Typography>
                            <Button
                                variant="contained"
                                onClick={() => setDrawerOpen(true)}
                                sx={{
                                    backgroundColor: buttonColor,
                                    borderRadius: '10px',
                                    textTransform: "none",
                                    "&:hover": { backgroundColor: buttonColorHover },
                                }}
                            >
                                Добавить
                            </Button>
                        </div>
                        {selectedBarcodesContent}
                    </div>
                }
            />

            {/* Шторка */}
            {productsDrawer}
        </div>
    );
});

const ProductRow = memo(function ProductRow({ 
    // @ts-ignore
    product, 
    // @ts-ignore
    onAdd 
}) {
    const bc = product?.size?.barcode ?? product?.data?.barcode;

    const handleAdd = useCallback(() => {
        onAdd(bc);
    }, [onAdd, bc]);

    return (
        <div
            style={{
                display: "flex",
                alignItems: "center",
                gap: "10px",
                padding: "10px",
                background: "white",
                borderRadius: "10px",
                boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
            }}
        >
            <div style={{ flex: 1, minWidth: 0 }}>
                <ProductMoreInfo value={product.data} />
            </div>
            <IconButton
                onClick={handleAdd}
                sx={{
                    color: buttonColor,
                    "&:hover": { backgroundColor: "rgba(7, 132, 118, 0.08)" },
                }}
            >
                <ArrowForwardIosIcon />
            </IconButton>
        </div>
    );
});

const DrawerContent = memo(function DrawerContent({
    // @ts-ignore
    availableProducts,
    // @ts-ignore
    addBarcode,
    // @ts-ignore
    addAllBarcodes,
    // @ts-ignore
    productSearchChecked, setProductSearchChecked,
    // @ts-ignore
    productSearch, setProductSearch,
}) {
    const drawerListRef = useRef(null);
    const PRODUCT_ROW_HEIGHT = 120;

    const virtualizer = useVirtualizer({
        count: availableProducts.length,
        getScrollElement: () => drawerListRef.current,
        estimateSize: () => PRODUCT_ROW_HEIGHT,
        overscan: 10,
        getItemKey: (index) => {
            const p = availableProducts[index];
            return p?.id ?? String(p?.size?.barcode ?? p?.data?.barcode ?? index);
        },
    });

    // Ключевое: следим за размером контейнера и пересчитываем
    useEffect(() => {
        const el = drawerListRef.current;
        if (!el) return;

        // Первичный замер (на случай, если высота уже есть)
        virtualizer.measure();

        const ro = new ResizeObserver(() => {
            virtualizer.measure();
        });
        ro.observe(el);

        return () => ro.disconnect();
    }, [virtualizer]);

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                height: "100%",
                padding: "20px",
                gap: "15px",
                boxSizing: "border-box",
            }}
        >
            {/* заголовок */}
            <div style={{ display: "flex", alignItems: "center" }}>
                <Typography sx={{ fontSize: "18px", fontWeight: "bold", color: buttonColor }}>
                    Добавить товары
                </Typography>
            </div>

            {/* поиск + кнопка */}
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <div style={{ flex: 1 }}>
                    <ClassicSearch
                        setChecked={setProductSearchChecked}
                        setFilter={setProductSearch}
                        checked={productSearchChecked}
                        // @ts-ignore
                        customWidth={"100%"}
                    />
                </div>
                <Button
                    variant="contained"
                    onClick={() => {
                        const barcodes = availableProducts
                            .map((p) => p?.size?.barcode ?? p?.data?.barcode)
                            .filter((b) => b !== undefined && b !== null);
                        addAllBarcodes(barcodes);
                    }}
                    sx={{
                        backgroundColor: buttonColor,
                        borderRadius: "10px",
                        textTransform: "none",
                        whiteSpace: "nowrap",
                        "&:hover": { backgroundColor: buttonColorHover },
                    }}
                >
                    Привязать все
                </Button>
            </div>

            {/* список */}
            <div
                ref={drawerListRef}
                className="custom-scrollbar"
                style={{ flex: 1, minHeight: 0, overflow: "auto" }}
            >
                {availableProducts.length === 0 ? (
                    <div style={{ padding: "10px", color: "#999" }}>
                        Нет доступных товаров
                    </div>
                ) : (
                    <div
                        style={{
                            height: virtualizer.getTotalSize(),
                            width: "100%",
                            position: "relative",
                        }}
                    >
                        {virtualizer.getVirtualItems().map((vi) => {
                            const p = availableProducts[vi.index];
                            return (
                                <div
                                    key={vi.key}
                                    style={{
                                        position: "absolute",
                                        top: 0,
                                        left: 0,
                                        width: "100%",
                                        height: PRODUCT_ROW_HEIGHT,
                                        transform: `translateY(${vi.start}px)`,
                                        paddingBottom: "10px",
                                        boxSizing: "border-box",
                                    }}
                                >
                                    <ProductRow 
                                        // @ts-ignore
                                        product={p} 
                                        onAdd={addBarcode} />
                                </div>
                            );
                        })}
                    </div>
                )}
            </div>
        </div>
    );
});

// ============================================================
// [FIX 7] Утилита гидратации фото — вместо 4-х повторов внутри useEffect
// ============================================================
async function hydratePhotos(data) {
    const fields = ["packff", "packcli", "consumabels", "addit_consumabels"];
    await Promise.all(
        fields.flatMap((field) =>
            (data[field] || []).map(async (el) => {
                if (el.photo) {
                    el.photo = await getFile("png", { path: el.photopath });
                }
            })
        )
    );
}